import React from "react";
import { useParams } from "react-router-dom";
import Permission from "components/permission";
import { useQuery } from "@apollo/client";
import { GET_PERMISSION } from "graphql/query/permission-gql";
import { PageWrapDefault } from "components/layout";
import { useActiveMenuItem } from "components/use-hooks";
import PermissionRoute from "components/routes/permission/permission-route";
import Localize, { localizeByKey } from "components/service/localize";
import type { TPermission } from "components/permission/helpers/permission-types-helper";

const PermissionPage: React.FC = () => {
    useActiveMenuItem(["permissions"], ["permissions"]);

    const { id } = useParams<{ id: string }>();
    const permissionID = id ? parseInt(id) : "create";
    const basePath = Permission.Const.basePath;

    const { data, loading } = useQuery<{ permission: TPermission }>(GET_PERMISSION, {
        skip: permissionID === "create",
        variables: {
            id: permissionID,
        },
    });

    const permission = data?.permission;

    const pageNavbar = [
        {
            label: localizeByKey("NAVBAR_PAGES.Label_Overview"),
            path: "",
        },
    ];

    return (
        <PageWrapDefault
            className="page-permission"
            loading={loading}
            title={
                permissionID === "create" ? (
                    <Localize>PAGES.Title_CreatePermission</Localize>
                ) : !loading && permission ? (
                    <Localize>{permission.slug}</Localize>
                ) : (
                    "Page 404"
                )
            }
            dataExist={permissionID === "create" ? true : !loading && permission !== undefined}
            pageNavbar={!loading && permission ? pageNavbar : undefined}
            staticPath={`${basePath}/${permissionID}`}
        >
            <PermissionRoute permission={permission} />
        </PageWrapDefault>
    );
};

export default PermissionPage;